// extracted by mini-css-extract-plugin
module.exports = {"root":"collection-slices_root__WQ1_j","callout":"collection-slices_callout__3MrS_","topBreakoutImage":"collection-slices_topBreakoutImage__YP6lP"};